import { config } from "../config";
import type { NumberRangeBaseFunction } from "./NumberRange";

function parseList(res: unknown): NumberRangeBaseFunction[] {
  const raw = Array.isArray((res as { results?: unknown })?.results)
    ? (res as { results: NumberRangeBaseFunction[] }).results
    : Array.isArray(res)
      ? (res as NumberRangeBaseFunction[])
      : [];
  return raw;
}

const TTL_MS = 45_000;

let cached: { list: NumberRangeBaseFunction[]; fetchedAt: number } | null = null;
let inflight: Promise<NumberRangeBaseFunction[]> | null = null;

/**
 * Fetches number-range base functions with deduplication (parallel callers share one HTTP request)
 * and a short TTL so Step1 can reuse data prefetched when EventConfigurator mounted.
 */
export async function getNumberRangeBaseFunctions(
  callApi: (url: string, method?: string) => Promise<unknown>,
  opts?: { force?: boolean }
): Promise<NumberRangeBaseFunction[]> {
  if (opts?.force) {
    cached = null;
    inflight = null;
  }
  if (!opts?.force && cached && Date.now() - cached.fetchedAt < TTL_MS) {
    return cached.list;
  }
  if (inflight) {
    return inflight;
  }
  const url = `${config.apiUrl}/api/number-range-base-function/?page_size=100`;
  inflight = (async () => {
    const res = await callApi(url, "GET");
    const list = parseList(res);
    cached = { list, fetchedAt: Date.now() };
    return list;
  })();
  try {
    return await inflight;
  } finally {
    inflight = null;
  }
}

/** Call after admin (or other) mutations so the creator sees updated bases/chips. */
export function invalidateNumberRangeBaseFunctionsCache(): void {
  cached = null;
  inflight = null;
}
